/* eslint-disable @typescript-eslint/no-explicit-any */
import { useCart, CartItem } from '../context/CartContext';
import { functions } from '../firebase';
import { httpsCallable } from 'firebase/functions';

// This is a custom hook to encapsulate the Razorpay payment logic.
const useRazorpay = () => {
  const { cart, getCartTotal, clearCart } = useCart();

  const displayRazorpay = async (billing?: { name?: string; email?: string; contact?: string; address?: string }) => {
    const totalAmount = getCartTotal();

    if (totalAmount <= 0) {
      alert('Your cart is empty.');
      return;
    }

    try {
      // Step 1: Create order server-side (prevents amount tampering)
      const createOrder = httpsCallable(functions, 'createRazorpayOrder');
      const orderResult = await createOrder({
        amount: totalAmount,
        cartItems: cart.map((item: CartItem) => ({
          id: item.id,
          name: item.name,
          price: item.price,
          quantity: item.quantity,
        })),
      });

      const orderData = orderResult.data as { orderId: string; amount: number; currency: string };

      const options = {
        key: process.env.REACT_APP_RAZORPAY_KEY_ID || '',
        amount: orderData.amount.toString(),
        currency: orderData.currency,
        name: 'Muchukunnu Temple',
        description: 'Pooja & Vazhipad Offerings',
        image: '/assets/header_god_image.png',
        order_id: orderData.orderId, // Server-generated order ID
        handler: async function (response: any) {
          try {
            // Step 2: Verify payment signature server-side
            const verifyPayment = httpsCallable(functions, 'verifyRazorpayPayment');
            await verifyPayment({
              razorpay_order_id: response.razorpay_order_id,
              razorpay_payment_id: response.razorpay_payment_id,
              razorpay_signature: response.razorpay_signature,
            });
            alert(`Payment successful! Payment ID: ${response.razorpay_payment_id}`);
            clearCart();
          } catch (verifyErr: any) {
            console.error('Payment verification failed:', verifyErr);
            alert('Payment could not be verified. Please contact temple administration with your payment ID: ' + response.razorpay_payment_id);
          }
        },
        prefill: {
          name: billing?.name || '',
          email: billing?.email || '',
          contact: billing?.contact || '',
        },
        notes: {
          address: billing?.address || '',
        },
        theme: {
          color: '#E63946',
        },
        modal: {
          ondismiss: function () {
            try {
              alert('Payment cancelled. You can retry or modify your order.');
            } catch (e) {
              /* ignore */
            }
          }
        }
      };

      const paymentObject = new (window as any).Razorpay(options);

      try {
        paymentObject.on && paymentObject.on('payment.failed', function (response: any) {
          console.error('Razorpay payment failed', response);
          alert('Oops! Something went wrong.\nPayment Failed');
        });
      } catch (e) {
        console.error('Error attaching payment.failed handler', e);
      }

      paymentObject.open();
    } catch (err: any) {
      console.error('Error creating order:', err);
      alert('Unable to initiate payment. Please try again later.');
    }
  };

  return displayRazorpay;
};

export default useRazorpay;
